import React from "react";
import BasicChartSearchMenu from "@/appComponents/Blocks/Menus/BasicChartSearchMenu/BasicChartSearchMenu";
import { isNullish, Pill, PillWrapper } from "@theorgchartdev/storybook";

// Helper for creating a single pill
export const createSinglePill = (item, onRemove, disabled, size = "medium", key = "0") => (
  <PillWrapper key={key}>
    <Pill
      size={size === "small" ? "compact" : "regular"}
      onRemove={
        onRemove
          ? e => {
              e.stopPropagation();
              onRemove(item);
            }
          : undefined
      }
      disabled={disabled}
      label={item.label}
    />
  </PillWrapper>
);

// Helper for creating multiple pills
export const createMultiplePills = (items, onRemove, disabled, size = "medium") => (
  <>
    {items.map((item, index) =>
      createSinglePill(item, onRemove, disabled, size, `${item.id || index}`)
    )}
  </>
);

export const SelectableSearchMenu = ({
  selectedItem,
  onRemoveItem,
  searchMenuProps = {},
  expandable = false,
  allowMultiSelect = true,
  ...props
}) => {
  // Handle empty label case
  if (selectedItem?.label === "") {
    selectedItem = null;
  }

  // Determine if we're dealing with an array of selected items or a single item
  const isMultiSelect = Array.isArray(selectedItem) && allowMultiSelect;
  const hasSingleItem = !isMultiSelect;

  const showSinglePill = !isNullish(selectedItem) && hasSingleItem;
  const showMultiplePills = !isNullish(selectedItem) && isMultiSelect && selectedItem?.length > 0;

  const pillSize = props?.pillSize || props?.inputSize || "medium";
  const isDisabled = searchMenuProps?.inputProps?.disabled;

  // Configure search props with appropriate prefix
  const configuredSearchProps = {
    ...searchMenuProps?.searchProps,
    // If expandable is true, or if we have multiple items, enable expandable mode
    expandable: expandable || showMultiplePills,
    prefixNode: showMultiplePills
      ? createMultiplePills(selectedItem, onRemoveItem, isDisabled, pillSize)
      : showSinglePill
        ? createSinglePill(selectedItem, onRemoveItem, isDisabled, pillSize)
        : undefined
  };

  return (
    <BasicChartSearchMenu
      {...props}
      searchMenuProps={{
        ...searchMenuProps,
        searchProps: configuredSearchProps
      }}
    />
  );
};
